import Head from "next/head";

export const BlogsPageHead = () => {
  return (
    <Head>
      <title>Blogs | Pod1um</title>
      <meta name="dc.title" content="Blogs | Pod1um" />
      <meta name="og:title" content="Blogs | Pod1um" />
      <meta name="twitter:title" content="Blogs | Pod1um" />
    </Head>
  );
};
